var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-mini-list',{attrs:{"items":_vm.list.items,"selectable":"","multi-select":false,"is-product":""},on:{"select":_vm.handleSelect}})}
var staticRenderFns = []

export { render, staticRenderFns }